import React from 'react';
import { IDiscardChangesModalProvider } from 'common/modals/DiscardChangesModal/DiscardChangesModalProvider';

const DiscardChangesContext = React.createContext<IDiscardChangesModalProvider | null>(null);

export default DiscardChangesContext;
